import { render, staticRenderFns } from "./headline--big.vue?vue&type=template&id=765f60b6&"
import script from "./headline--big.vue?vue&type=script&lang=js&"
export * from "./headline--big.vue?vue&type=script&lang=js&"
import style0 from "./headline--big.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports